import { createSlice } from "@reduxjs/toolkit";

export const icabsProductListSlice = createSlice({
  name: "icabsProductListSlice",
  initialState: {
    icabsProductList: [],
  },
  reducers: {
    setIcabsProductList: (currentSlice, action) => {
      currentSlice.icabsProductList = action.payload;
    },
  },
});

export const { setIcabsProductList } = icabsProductListSlice.actions;
export const icabsProductListReducer = icabsProductListSlice.reducer;
